import {CsvConstraint} from '@/helpers/csv/CsvValidation';

export const massImportCsvConstraints: Map<number, CsvConstraint> = new Map()
    .set( 0, new CsvConstraint(new RegExp('^\\d+$'), 'Cug'))
    .set( 1, new CsvConstraint(new RegExp('.*'), 'Origine'))
    .set( 2, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire lundi'))
    .set( 3, new CsvConstraint(new RegExp('^\\d+$'), 'Délai lundi'))
    .set( 4, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire mardi'))
    .set( 5, new CsvConstraint(new RegExp('^\\d+$'), 'Délai mardi'))
    .set( 6, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire mercredi'))
    .set( 7, new CsvConstraint(new RegExp('^\\d+$'), 'Délai mercredi'))
    .set( 8, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire jeudi'))
    .set( 9, new CsvConstraint(new RegExp('^\\d+$'), 'Délai jeudi'))
    .set(10, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire vendredi'))
    .set(11, new CsvConstraint(new RegExp('^\\d+$'), 'Délai vendredi'))
    .set(12, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire samedi'))
    .set(13, new CsvConstraint(new RegExp('^\\d+$'), 'Délai samedi'))
    .set(14, new CsvConstraint(new RegExp('^\\d+$|^illimité$'), 'Capacitaire dimanche'))
    .set(15, new CsvConstraint(new RegExp('^\\d+$'), 'Délai dimanche'))
    .set(16, new CsvConstraint(new RegExp('.*'), 'Type production'))
    .set(17, new CsvConstraint(new RegExp('.*'), 'Méthode production'))
    .set(18, new CsvConstraint(new RegExp('.*'), 'Nom scientifique'))
    .set(19, new CsvConstraint(new RegExp('.*'), 'Pays élevage'))
    .set(20, new CsvConstraint(new RegExp('.*'), 'Technique pêche'))
    .set(21, new CsvConstraint(new RegExp('.*'), 'Zone pêche'))
    .set(22, new CsvConstraint(new RegExp('.*'), 'Sous zone pêche'));